/**
 * Tiny indirection over `window.location.assign` so the React Copy / Copy as
 * template dialogs can hand off to the new project URL after a successful
 * copy without coupling the dialog to a global API that is non-configurable
 * (and therefore non-mockable) in browser test harnesses.
 *
 * Tests `vi.mock` this module to capture the URL without actually navigating
 * the test iframe.
 */
export function navigateToHtmlUrl(url: string): void {
  window.location.assign(url)
}
